import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Accordion as MUIAccordion, AccordionDetails as MUIAccordionDetails, AccordionSummary as MUIAccordionSummary, FormControlLabel as MUIFormControlLabel, } from "@mui/material";
import { convertPxToRem } from "../../../util-functions";
import { Icon } from "../../Icon";
import { Checkbox } from "../../Checkbox";
export const StyledAccordionSelector = styled(MUIAccordion)(({ theme }) => ({
    boxShadow: "none",
    "::before": {
        backgroundColor: theme.palette.grey04.main,
    },
    "&.Mui-expanded::before": {
        opacity: 1,
    },
}));
export const StyledFormControlLabel = styled(MUIFormControlLabel)({
    "& .MuiFormControlLabel-label": {
        marginLeft: convertPxToRem(10),
    },
});
export const StyledAccordionSelectorHeader = styled(MUIAccordionSummary)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.largeText), { color: theme.palette.primaryBlackText.main, flexDirection: "row-reverse", minHeight: convertPxToRem(52), height: convertPxToRem(52), padding: 0, "& .MuiAccordionSummary-expandIconWrapper": {
        marginRight: convertPxToRem(16),
        "&.Mui-expanded": {
            transform: "rotate(90deg)",
            // arrow icon - the expanded color passed into Icon only works when the expanded prop is being used. this is to cover single AccordionSelectors
            ">span": {
                color: theme.palette.primaryBlack.main,
            },
        },
    }, "& .MuiFormControlLabel-root": {
        margin: 0,
    }, "&.Mui-expanded": Object.assign({ borderBottom: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}` }, theme.typography.largeTextStrong) })));
export const StyledAccordionDetails = styled(MUIAccordionDetails)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.largeText), { color: theme.palette.primaryBlackText.main, display: "flex", flexDirection: "column", padding: `0 0 0 ${convertPxToRem(40)}`, "& .MuiAccordionSummary-expandIconWrapper": {
        marginRight: convertPxToRem(16),
        "&.Mui-expanded": {
            transform: "rotate(90deg)",
        },
    }, "& .MuiFormControlLabel-root": {
        borderBottom: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}`,
        margin: 0,
        minHeight: convertPxToRem(52),
    } })));
export const AccordionSelector = ({ checkboxes, headerCheckbox, expanded, onChange: panelOnChange, testId, }) => {
    const { key: headerKey, label: headerLabel, testId: headerTestId, value: headerValue, } = headerCheckbox;
    const panelCheckboxes = [...checkboxes];
    const numberOfCheckedCheckboxes = panelCheckboxes.filter((checkbox) => checkbox.checked).length;
    return (_jsxs(StyledAccordionSelector, Object.assign({ "data-testid": testId, expanded: expanded, onChange: panelOnChange, disableGutters: true }, { children: [_jsx(StyledAccordionSelectorHeader, Object.assign({ id: `header-${headerLabel}`, "aria-controls": `content-${headerLabel}`, expandIcon: _jsx(Icon, { iconName: "ArrowDropright", fontSize: "large", color: expanded ? "primaryBlack" : "grey08" }) }, { children: _jsx(StyledFormControlLabel, { "aria-label": headerLabel, label: headerLabel, onClick: (event) => event.stopPropagation(), onFocus: (event) => event.stopPropagation(), control: _jsx(Checkbox, { "data-testid": headerTestId && `headerCheckbox-${headerTestId}`, label: headerLabel, hideLabel: true, value: headerValue, checked: numberOfCheckedCheckboxes === panelCheckboxes.length, useDashIcon: numberOfCheckedCheckboxes > 0 &&
                            numberOfCheckedCheckboxes < panelCheckboxes.length, onChange: () => headerCheckbox.onChange(headerKey) }) }) })), _jsx(StyledAccordionDetails, Object.assign({ "data-testid": testId && `accordion-selector-panel-${testId}` }, { children: panelCheckboxes.map((checkbox) => {
                    const { key, checked, label, value, onChange, testId: checkboxTestId, } = checkbox;
                    return (_jsx(StyledFormControlLabel, { label: label, control: _jsx(Checkbox, { "data-testid": checkboxTestId && `panelCheckbox-${checkboxTestId}`, label: label, hideLabel: true, checked: checked, value: value, onChange: () => {
                                onChange(key, !checked);
                            } }) }, key));
                }) }))] })));
};
